import * as React from 'react';
import { getAuthToken, isUserLoggedIn } from '@/redux/modules/user';
import Cookies from 'universal-cookie';
import usePrevious from '@/hooks/usePrevious';
import { useSelector } from 'react-redux';

const cookie = new Cookies();

const Auth = () => {
    const authToken = useSelector(getAuthToken);
    const userLoggedIn = useSelector(isUserLoggedIn);
    const prevAuthToken = usePrevious(authToken);
    const prevUserLoggedIn = usePrevious(userLoggedIn);

    const getExp = React.useCallback((token: string = '') => {
        const splitToken = token.split('.');
        if (splitToken.length < 2) {
            console.warn('Failed to decode JWT expiration');
            return;
        }
        try {
            if (!atob(splitToken[1])) {
                return;
            }
            const payload = JSON.parse(atob(splitToken[1]));
            return new Date(payload.exp * 1000);
        } catch (e) {
            console.warn('Failed to decode JWT expiration', e);
            return new Date(0);
        }
    }, []);

    const setAuthCookie = React.useCallback((authToken: string, expires: any) => {
        cookie.set('bidder-auth', authToken, {
            domain: '.liveauctioneers.com',
            expires,
            path: '/',
            sameSite: 'none',
            secure: true,
        });
    }, []);

    const unsetCookies = React.useCallback(() => {
        cookie.remove('auctioneer-auth', { domain: '.liveauctioneers.com', path: '/' });
        cookie.remove('bidder-auth', { domain: '.liveauctioneers.com', path: '/' });
    }, []);

    React.useEffect(() => {
        if (authToken && authToken !== prevAuthToken) {
            const expires = getExp(authToken);
            setAuthCookie(authToken, expires);
        } else if (prevUserLoggedIn && !userLoggedIn) {
            unsetCookies();
        }
    }, [authToken, getExp, prevAuthToken, prevUserLoggedIn, setAuthCookie, unsetCookies, userLoggedIn]);

    return null;
};

export default Auth;
